import {
  LIST_EMR_MEDICAL_DOCS_REQUEST,
  LIST_EMR_MEDICAL_DOCS_SUCCESS,
  LIST_EMR_MEDICAL_DOCS_FAIL,
  LIST_EMR_MEDICAL_DOCS_SUMMARY_REQUEST,
  LIST_EMR_MEDICAL_DOCS_SUMMARY_SUCCESS,
  LIST_EMR_MEDICAL_DOCS_SUMMARY_FAIL,
  CREATE_EMR_MEDICAL_DOCS_REQUEST,
  CREATE_EMR_MEDICAL_DOCS_SUCCESS,
  CREATE_EMR_MEDICAL_DOCS_FAIL,
  DETAIL_EMR_MEDICAL_DOCS_REQUEST,
  DETAIL_EMR_MEDICAL_DOCS_SUCCESS,
  DETAIL_EMR_MEDICAL_DOCS_FAIL,
  UPDATE_EMR_MEDICAL_DOCS_REQUEST,
  UPDATE_EMR_MEDICAL_DOCS_SUCCESS,
  UPDATE_EMR_MEDICAL_DOCS_FAIL,
  DELETE_EMR_MEDICAL_DOCS_REQUEST,
  DELETE_EMR_MEDICAL_DOCS_SUCCESS,
  DELETE_EMR_MEDICAL_DOCS_FAIL,
  RESET_EMR_MEDICAL_DOCS
} from '../../constants/emr-medical-documents'

const initialState = {
  loadingEmrMedicalDocs: false,
  loadingPatchDelete: false,
  emrMedicalDocs: [],
  emrMedicalDoc: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const emrMedicalDocumentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_EMR_MEDICAL_DOCS_REQUEST:
      return {
        ...state,
        loadingEmrMedicalDocs: true,
        emrMedicalDocs: []
      }
    case LIST_EMR_MEDICAL_DOCS_SUCCESS:
      return {
        ...state,
        loadingEmrMedicalDocs: false,
        emrMedicalDocs: action.payload,
        pageable: action.pageable
      }
    case LIST_EMR_MEDICAL_DOCS_FAIL:
      return {
        ...state,
        loadingEmrMedicalDocs: false,
        error: action.payload,
        emrMedicalDocs: []
      }
    case LIST_EMR_MEDICAL_DOCS_SUMMARY_REQUEST:
      return {
        ...state,
        loadingEmrMedicalDocs: true,
        emrMedicalDocs: []
      }
    case LIST_EMR_MEDICAL_DOCS_SUMMARY_SUCCESS:
      return {
        ...state,
        loadingEmrMedicalDocs: false,
        emrMedicalDocs: action.payload
      }
    case LIST_EMR_MEDICAL_DOCS_SUMMARY_FAIL:
      return { ...state, loadingEmrMedicalDocs: false, error: action.payload }
    case CREATE_EMR_MEDICAL_DOCS_REQUEST:
      return { ...state, loadingPatchDelete: true }
    case CREATE_EMR_MEDICAL_DOCS_SUCCESS:
      return { ...state, loadingPatchDelete: false }
    case CREATE_EMR_MEDICAL_DOCS_FAIL:
      return { ...state, loadingPatchDelete: false, error: action.payload }
    case DETAIL_EMR_MEDICAL_DOCS_REQUEST:
      return { ...state, loadingPatchDelete: true, emrMedicalDoc: {} }
    case DETAIL_EMR_MEDICAL_DOCS_SUCCESS:
      return {
        ...state,
        loadingPatchDelete: false,
        emrMedicalDoc: action.payload
      }
    case DETAIL_EMR_MEDICAL_DOCS_FAIL:
      return { ...state, loadingPatchDelete: false, error: action.payload }
    case UPDATE_EMR_MEDICAL_DOCS_REQUEST:
      return { ...state, loadingPatchDelete: true }
    case UPDATE_EMR_MEDICAL_DOCS_SUCCESS:
      return { ...state, loadingPatchDelete: false }
    case UPDATE_EMR_MEDICAL_DOCS_FAIL:
      return { ...state, loadingPatchDelete: false, error: action.payload }
    case DELETE_EMR_MEDICAL_DOCS_REQUEST:
      return { ...state, loadingPatchDelete: true }
    case DELETE_EMR_MEDICAL_DOCS_SUCCESS:
      return { ...state, loadingPatchDelete: false }
    case DELETE_EMR_MEDICAL_DOCS_FAIL:
      return { ...state, loadingPatchDelete: false, error: action.payload }
    case RESET_EMR_MEDICAL_DOCS:
      return { ...state, loading: false, error: null }
    default:
      return state
  }
}

export default emrMedicalDocumentsReducer
